import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';

const AuthGuard = ({ children }) => {
  const [isAuthenticated, setIsAuthenticated] = useState(false);
  const [isLoading, setIsLoading] = useState(true);
  const navigate = useNavigate();

  useEffect(() => {
    const checkAuth = () => {
      const token = localStorage.getItem('token');
      const user = localStorage.getItem('user');
      
      console.log('AuthGuard - Token exists:', !!token);
      console.log('AuthGuard - User exists:', !!user);
      
      if (token && user) {
        try {
          const userData = JSON.parse(user);
          console.log('AuthGuard - User data:', userData);
          setIsAuthenticated(true);
        } catch (error) {
          console.error('AuthGuard - Invalid user data:', error);
          localStorage.removeItem('token');
          localStorage.removeItem('user');
          navigate('/admin/login');
        }
      } else {
        console.log('AuthGuard - No authentication found, redirecting to login');
        navigate('/admin/login');
      }
      
      setIsLoading(false);
    };

    checkAuth();
  }, [navigate]);

  if (isLoading) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-gray-50">
        <div className="animate-spin rounded-full h-8 w-8 border-b-2 border-blue-600"></div>
      </div>
    );
  }

  if (!isAuthenticated) {
    return null;
  }

  return children;
};

export default AuthGuard;